import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/(site)/berita/page.tsx");
